import { render, staticRenderFns } from "./CodConfirm.vue?vue&type=template&id=e498a484&scoped=true&"
import script from "./CodConfirm.vue?vue&type=script&lang=js&"
export * from "./CodConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CodConfirm.vue?vue&type=style&index=0&id=e498a484&prod&lang=scss&"
import style1 from "./CodConfirm.vue?vue&type=style&index=1&id=e498a484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e498a484",
  null
  
)

export default component.exports